import { getField, updateField } from "vuex-map-fields";
import { VuexModule, Module, Action } from "vuex-module-decorators";
import SurveyService from "@/views/sidebar/survey/survey.service";
import { SurveyResult, AlertZone, AssessmentTypes } from "@/views/sidebar/survey/survey.types";

@Module({ namespaced: true })
class Survey extends VuexModule {
  surveyAnswers: SurveyResult[] = [];
  phq9AlertZones: AlertZone[] = [];
  gad7AlertZones: AlertZone[] = [];
  sowsAlertZones: AlertZone[] = [];
  bamAlertZones: AlertZone[] = [];

  private _initialState!: Record<string, any>;

  constructor(module: any) {
    super(module);
    this._initialState = { ...this };
  }

  @Action({ rawError: true })
  async fetchSurveyAnswers({ participantId, clientId, timezone } : { participantId: number, clientId: number, timezone: string }) {
    this.context.commit("updateField", {
      path: "surveyAnswers",
      value: []
    });
    const surveyAnswers = await SurveyService.getSurveyAnswers(clientId, participantId, timezone);
    this.context.commit("updateField", {
      path: "surveyAnswers",
      value: surveyAnswers
    });
  }

  @Action({ rawError: true })
  async fetchPhq9ChartOptions(clientId: number) {
    const phq9AlertZones = await SurveyService.getAlertZones(AssessmentTypes.PHQ9, clientId);
    this.context.commit("updateField", {
      path: "phq9AlertZones",
      value: phq9AlertZones
    });
  }

  @Action({ rawError: true })
  async fetchGad7ChartOptions(clientId: number) {
    const gad7AlertZones = await SurveyService.getAlertZones(AssessmentTypes.GAD7, clientId);
    this.context.commit("updateField", {
      path: "gad7AlertZones",
      value: gad7AlertZones
    });
  }
  
  @Action({ rawError: true })
  async fetchSowsChartOptions(clientId: number) {
    const sowsAlertZones = await SurveyService.getAlertZones(AssessmentTypes.SOWS, clientId);
    this.context.commit("updateField", {
      path: "sowsAlertZones",
      value: sowsAlertZones
    });
  }

  @Action({ rawError: true })
  async fetchBamChartOptions(clientId: number) {
    const bamAlertZones = await SurveyService.getAlertZones(AssessmentTypes.BAM, clientId);
    this.context.commit("updateField", {
      path: "bamAlertZones",
      value: bamAlertZones
    });
  }

  @Action({ rawError: true })
  resetState() {
    for (const key of Object.keys(this._initialState)) {
      this.context.commit("updateField", {
        path: key,
        value: this._initialState[key]
      });
    }
  }
}

Survey.getters = { getField };
Survey.mutations = { updateField };

export default Survey;
